import { useEffect, useState } from 'react';
import LuckyCalImage from '../../images/events/lucky-calendar-2027.jpg';
import { Container, Row, Col, Button, Card, Carousel, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import LuckyNumbersService from '../../services/LuckyNumbersService';
import { DateTime } from 'luxon';

function LuckyCalendarPage() {

  const luckyNumberService = new LuckyNumbersService();
  const [luckyNumInfo, setLuckyNumInfo] = useState<any>({});

  const getLuckyNumbers = async () => {
    const lnResp = await luckyNumberService.getLuckyNumbers();
    setLuckyNumInfo(lnResp?.data);
  }

  const formatISODate = (isoDate: string, format: string) => {
    const dt = DateTime.fromISO(isoDate);
    return dt.isValid ? dt.toFormat(format) : isoDate;
  }

  useEffect(() => {
    getLuckyNumbers();
  }, []);

  return (
    <div className="lucky-page">
      <section className="principles-hero">
        <Container>
          <div className="eyebrow">Fundraiser for St. Mary Catholic Church</div>
          <h1>Lucky Number Calendar</h1>
        </Container>
      </section>

      <Container className="lucky-content">
        <Row className="g-4 align-items-center">
          <Col lg="6">
            {luckyNumInfo.currentDate && <Carousel variant="dark" indicators={false} className="lucky-carousel">
              <Carousel.Item interval={12000}>
                <Card className="lucky-card">
                  <Card.Header className="text-center"><h4 className="mb-0">{formatISODate(luckyNumInfo.currentDate, "cccc, LLLL dd, yyyy")}</h4></Card.Header>
                  <Card.Body>
                    <div className="text-center">
                      <span className="fs-1"><Badge className="lucky-badge">{luckyNumInfo.currentNumber}</Badge></span>
                    </div>
                    <Card.Footer className="text-center fs-6">Next Drawing, {formatISODate(luckyNumInfo.nextDate, "LLLL dd, yyyy")}</Card.Footer>
                  </Card.Body>
                </Card>
              </Carousel.Item>

              {luckyNumInfo.luckyNumbers?.map((lrec: any, index: number) =>
                (index >= 1 && index <= 5) && <Carousel.Item key={index} interval={2700}>
                  <Card className="lucky-card">
                    <Card.Header className="text-center"><h4 className="mb-0">{formatISODate(lrec?.date, "cccc, LLLL dd, yyyy")}</h4></Card.Header>
                    <Card.Body>
                      <div className="text-center">
                        <span className="fs-1"><Badge className="lucky-badge lucky-badge-past">{lrec?.number}</Badge></span>
                      </div>
                      <Card.Footer className="text-center fs-6">If you won, expect payment in 1-2 weeks</Card.Footer>
                    </Card.Body>
                  </Card>
                </Carousel.Item>
              )}
            </Carousel>}

            {/* <div className="text-center mt-4">
              <Link to="/purchasecalendar"><Button size="lg" className="btn-navy">Purchase/Register 2027 Lucky Calendar</Button></Link>
            </div> */}
          </Col>
          <Col lg="6" className="text-center">
            <img src={LuckyCalImage} className="lucky-cal-img" alt="Lucky Number Calendar 2027 - St. Mary Church, Knights of Columbus #1056" />
          </Col>
        </Row>

        <Card className="lucky-card lucky-how mt-5">
          <Card.Body>
            <h3 className="lucky-section-title">How does it work?</h3>
            <ul className="fs-5 lucky-list">
              <li>It works like a raffle that happens every day!</li>
              <li>By purchasing a calendar ($30), you will receive a number ranging from 000 to 999.</li>
              <li>Each day of the week in 2027, except Sundays, you have a chance of winning $50 if your number is drawn.</li>
              <li>On a special day each month, you could win $100.</li>
              <li>We will use the <u>evening</u> Ohio Pick 3 number as our random number for the raffle. This ensures that the number is truly random.</li>
              <li>If you win, we will send your money to you within 1 to 2 weeks. If payment doesn't arrive, please contact us at <a href="mailto:kofc1056.luckycalendar@gmail.com">kofc1056.luckycalendar@gmail.com</a>.</li>
              <li>We only ask for your name, address, email &amp; phone so that we can send you the money if you win. We will not sell or distribute this data.</li>
              <li>Many people give these as gifts. On the purchase screen you'll have the option to provide the name / address for each calendar you purchase. This is where the money will be sent if their lucky number is drawn.</li>
              <li>All of the profits will go to St Mary Catholic Church.</li>
            </ul>
            <p className="fs-5 mb-4">For questions, please email <a href="mailto:kofc1056.luckycalendar@gmail.com">kofc1056.luckycalendar@gmail.com</a></p>
            {/* <div className="text-center">
              <Link to="/purchasecalendar"><Button size="lg" className="btn-navy">Purchase/Register 2027 Lucky Calendar</Button></Link>
            </div> */}
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}

export default LuckyCalendarPage;
